import safeJSONParse from '../../lib/safeJSONParse.js';
import mapToCamelCase from '../../lib/mapToCamelCase.js';

const formatLead = (lead = {}) => {
  return {
    ...lead,
    activity: lead.activity.map((n) => ({
      ...mapToCamelCase(n),
      creationDatetime: n.event_datetime,
      event: mapToCamelCase(safeJSONParse(n.event)),
    })),
  };
};

export default formatLead;
